import { ChakraProvider } from '@chakra-ui/react';
import React from 'react';
import theme from '../../common/chakra-theme.js';
import {
  Container,
  Slab
} from "../../common/index.js";
import { GlobalStyle } from '../../common/style.js';
import Footer from '../../footer/index.js';
import Header from '../../header/header2.js';
import SEO from '../../seo.js';
import { RemoveBG } from "../../tools/remove-background";
import { OtherTools, ToolsGrid } from "./index.js";
import FeatureShowCase from "../../../components/featuresShowcase"
import { featureSection } from "../../../data/solutions/how-imagekit-uses-ai"
import TopBanner from "../../TopBanner"

const BackgroundRemoval = () => {
  return (
    <>
      <GlobalStyle />
      <ChakraProvider theme={theme}>
        <TopBanner />
        <Header spaceFromTop={"110px"} />
        <SEO
          title="Remove background from images"
          description="Automatically remove background from images in seconds. Unlimited usage, no watermarks, and no registration required."
          appendSiteName={false}
          ogImage={"https://ik.imagekit.io/ikmedia/remove-bg-tool.png?tr=w=1200,f-jpg"}
        />
        <Slab>
          <Container>
            <RemoveBG />
          </Container>
        </Slab>
        <OtherTools />
        <FeatureShowCase features={featureSection} />
        <Footer gettingStartedText={"Adopt real-time image and video transformation."} />
      </ChakraProvider>
    </>
  );
};

export default BackgroundRemoval; 